import { useRouter } from "next/router";
import { FiX } from "react-icons/fi";
import { BaseMultipleAccordion } from "../../../../../components/accordion/container/base-multiple";
import Buttons from "../../../../../components/button";
import { ThreeColumn } from "../../../../../components/layouts/three-column";
import { PanelService } from "../../../../../components/services/panel.service";
import { When } from "../../../../../components/when";

export const JobFilterContainer = (props: {
  children: React.ReactNode;
  baseUrl: string;
  className?: string;
  showCloseButtonForMobile?: boolean;
}) => {
  const router = useRouter();

  const resetQueryParams = () => {
    // Keep the user's search query and sort
    const search = router.query.search;
    const sort = router.query.sort;

    const parts = [
      {
        key: "search",
        value: search,
      },
      {
        key: "sort",
        value: sort,
      },
    ];
    const usefulParts = parts.filter((p) => p.value);

    const url = `${props.baseUrl}${
      usefulParts.length > 0 ? "?" : ""
    }${usefulParts
      .map((p) => {
        return `${p.key}=${p.value}`;
      })
      .join("&")}`;
    router.replace(url);
  };

  return (
    <BaseMultipleAccordion className={props.className}>
      <ThreeColumn.Container className="items-center justify-between pb-5">
        <ThreeColumn.Content>
          <h1 className="text-xl font-semibold leading-none">Filters</h1>
        </ThreeColumn.Content>
        <ThreeColumn.Trailing>
          <div className="flex items-center gap-x-2">
            <Buttons.Micro
              onClick={() => resetQueryParams()}
              variant="base"
              className="text-navy"
            >
              Clear All
            </Buttons.Micro>
            <When condition={props.showCloseButtonForMobile}>
              <Buttons.Base
                onClick={() => PanelService.close()}
                variant="secondary"
                className="h-11 w-11"
              >
                <FiX />
              </Buttons.Base>
            </When>
          </div>
        </ThreeColumn.Trailing>
      </ThreeColumn.Container>
      <div className="flex w-full flex-col">{props.children}</div>
    </BaseMultipleAccordion>
  );
};
